import React from "react";

import PageHero from "components/site/PageHero";
import RevealBlock from "components/site/RevealBlock";
import { Col, Container, Row } from "components/site/SitePrimitives";
import SiteShell from "components/site/SiteShell";
import {
  buildStructuredData,
  contactPage,
} from "content/siteContent";
import usePageMeta from "hooks/usePageMeta";

function ContactUs() {
  usePageMeta({
    ...contactPage.meta,
    structuredData: buildStructuredData({
      pageName: "Contact",
      description: contactPage.meta.description,
      path: contactPage.meta.path,
    }),
  });

  return (
    <SiteShell pageClassName="ignitum-site-page ignitum-contact-page">
      <PageHero
        aside={
          <RevealBlock variant="card">
            <p className="site-panel-label">Conversation fit</p>
            <ul className="site-signal-list">
              {contactPage.hero.signals.map((signal) => (
                <li key={signal}>{signal}</li>
              ))}
            </ul>
          </RevealBlock>
        }
        compact
        description={contactPage.hero.description}
        eyebrow={contactPage.hero.eyebrow}
        title={contactPage.hero.title}
      />

      <section className="site-section">
        <Container>
          <Row className="site-card-grid">
            <Col lg="6">
              <RevealBlock variant="slide-left">
                <div className="site-card site-split-card">
                  <p className="site-card-label">Good fit</p>
                  <h3>Conversations that usually make sense</h3>
                  <ul className="site-good-fit-list">
                    {contactPage.goodFit.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </RevealBlock>
            </Col>
            <Col lg="6">
              <RevealBlock delay={80} variant="slide-right">
                <div className="site-card site-split-card">
                  <p className="site-card-label">Reach out</p>
                  <h3>Ways to connect</h3>
                  <ul className="site-response-list">
                    {contactPage.response.map((item) => (
                      <li key={item.label}>
                        <span className="site-response-label">{item.label}</span>
                        <a
                          className="site-response-link"
                          href={item.href}
                          rel={
                            item.href.startsWith("mailto:")
                              ? undefined
                              : "noopener noreferrer"
                          }
                          target={
                            item.href.startsWith("mailto:") ? undefined : "_blank"
                          }
                        >
                          {item.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <p className="site-contact-note">{contactPage.note}</p>
                </div>
              </RevealBlock>
            </Col>
          </Row>
        </Container>
      </section>
    </SiteShell>
  );
}

export default ContactUs;
